/* global $ */

var nutrient_search = function () {
  var self = this;

  this.searchInput = $('.nutrient-search-input');
  this.typeAheadResult = $('#nutrient-search-type-ahead-result');
  this.typeAheadTimeout = null;
  this.categoryFilter = null;
  this.allowedKeyInHash = ['q', 'category'];
  this.searchPath = `/${window.location.pathname.split('/')[1]}`;

  this.init = function () {
    $(document).on('change', '.nutrient-search-input', this.handleSearchBoxChangeEvent);
    $(document).on('blur', '.nutrient-search-input', this.handleSearchBoxBlurEvent);
    $(document).on('keyup', '.nutrient-search-input', this.handleSearchBoxKeUpEvent);
    $(document).on('click', '.nutrient-filter', this.handleNutrientFilterClickedEvent);

    this.readHash();
    this.updateFilterState();
    if (this.searchInput.val() !== '' || this.categoryFilter !== '') {
      $('#nutrient-loading-indicator').show();
      this.search(this.searchDoneCallback);
    }
  }.bind(this);

  this.handleSearchBoxChangeEvent = function () {
    this.searchInput.blur();
    this.search(this.searchDoneCallback);
  }.bind(this);

  this.handleSearchBoxKeUpEvent = function () {
    window.clearTimeout(this.typeAheadTimeout);
    this.typeAheadTimeout = window.setTimeout(this.search, 200, this.typeAheadSearchDoneCallback);
  }.bind(this);

  this.handleSearchBoxBlurEvent = function () {
    this.typeAheadResult.removeClass('isVisible');
  }.bind(this);

  this.handleNutrientFilterClickedEvent = function (e) {
    e.preventDefault();
    this.categoryFilter = $(e.target).data('category');
    this.updateFilterState();
    this.search(this.searchDoneCallback);
  }.bind(this);

  this.searchDoneCallback = function (result) {
    this.updateFilterState();
    $('.nutrient-tile').hide();
    $('#nutrient-loading-indicator').hide();
    result.result.forEach(function (item) {
      $('.nutrient-tile[data-name="' + item.title + '"]').show();
    });

    $('.nutrient-filter').filter(':not([data-category=null])').hide();
    result.filter[0].values.forEach(function (item) {
      $('.nutrient-filter[data-category="' + item.value + '"]').show();
    });
  }.bind(this);

  this.typeAheadSearchDoneCallback = function (result) {
    if (this.searchInput.val().length === 0) {
      self.typeAheadResult.removeClass('isVisible');
      return;
    }

    result.result = result.result.slice(0, 4);
    self.typeAheadResult.children('li').remove();
    result.result.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.uri;
      a.title = item.title;
      a.textContent = item.title;
      li.appendChild(a);
      self.typeAheadResult.append(li);
    });
    self.typeAheadResult.addClass('isVisible');
  }.bind(this);

  this.updateFilterState = function () {
    $('.nutrient-filter').removeClass('active');
    if (this.categoryFilter === null) {
      $('.nutrient-filter[data-category="null"]').addClass('active');
    }
    $('.nutrient-filter[data-category="' + this.categoryFilter + '"]').addClass('active');
  }.bind(this);

  this.search = function (callback) {
    let searchData = {};

    const query = this.searchInput.val();
    if (query) {
      searchData['q'] = query;
    }

    if (this.categoryFilter !== null) {
      searchData['category'] = [this.categoryFilter];
    }

    this.updateHash(searchData);

    $.ajax({
      url: this.searchPath + '/search/nutrient',
      data: searchData,
      method: 'GET',
    }).done(function (e) {
      callback(e);
    });
  }.bind(this);

  this.readHash = function () {
    var hashValues = this.parseHashParameters();
    this.searchInput.val(hashValues['q'] || '');
    this.categoryFilter = hashValues['category'] || null;
  }.bind(this);

  this.parseHashParameters = function (aUrl) {
    if (aUrl === null || aUrl === '') {
      return {};
    }

    aUrl = aUrl || window.location.hash;
    var vars = {};
    var hashes = aUrl.slice(aUrl.indexOf('#') + 1).split('&');

    hashes = hashes.filter(function (x) {
      return x !== '';
    });

    for (var i = 0; i < hashes.length; i++) {
      var hash = hashes[i].split('='),
        facetPart = hash[0].toLowerCase();
      if (hash.length > 1) {
        vars[decodeURIComponent(facetPart)] = decodeURIComponent(hash[1].replace('+', ' '));
      } else {
        vars[decodeURIComponent(facetPart)] = null;
      }
    }
    return vars;
  };

  this.updateHash = function (values) {
    var hashValues = [];
    $.each(values, function (key, value) {
      if (self.allowedKeyInHash.indexOf(key) !== -1) {
        hashValues.push(key + '=' + encodeURIComponent(value));
      }
    });

    var hashString = '#' + hashValues.join('&');
    const currentHash = window.location.hash;
    if (hashString !== currentHash && !(currentHash === '' && hashString === '#')) {
      history.pushState(null, null, hashString);
    }
  }.bind(this);

  this.init();
};

if ($('.nutrient-search-input').length > 0) {
  new nutrient_search();
}
